// extracted by mini-css-extract-plugin
export default {"description":"description-OKVL7Prr"};